import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as api from '../../api/apiConnector.js';
import waiting from '../../assets/images/waiting.svg';

const OAuth_Callback_Screen = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const processedCodeRef = useRef(null);

    useEffect(() => {

        if (localStorage.getItem('user')) {
            navigate('/', { replace: true }); // niente full reload
            return;
        }

        (async () => {

            const params = new URLSearchParams(location.search);
            const code = params.get('code');

            if (!code) return;

            // 🔒 Evita doppie chiamate (React StrictMode, retry, proxy prefetch)
            if (processedCodeRef.current === code) return;
            processedCodeRef.current = code;

            const ssKey = `oauth_code_used:${code}`;
            if (sessionStorage.getItem(ssKey)) return;
            sessionStorage.setItem(ssKey, '1');

            try {
                const result = await api.sendMessage('security/OAuthCheckTokenAPI', {
                    body: { code }
                });

                if (result?.success && result.user) {
                    result.user.token = result.token;
                    localStorage.setItem('user', JSON.stringify(result.user));
                    navigate('/', { replace: true });
                } else {
                    console.error('OAuth check failed');
                    navigate('/afterLoginError', { replace: true });
                }
            } catch (err) {
                console.error('OAuth exchange error', err);
                navigate('/afterLoginError', { replace: true });
            }
        })();
    }, [location.search, navigate]);

    return (
        <div id="preloader">
            <div className="lds-ripple">
                <div></div>
                <div></div>
            </div>
            <div className="text-center">
                <img src={waiting} alt="waiting" />
            </div>
        </div>
    );
};

export default OAuth_Callback_Screen;